import { Fragment, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  close: {
    padding: theme.spacing(0.5)
  },
  wrapper: {
    display: 'flex',
    maxWidth: 400
  },
  form: {
    flexGrow: 1
  },
  input: {
    width: '100%'
  },
  inputControl: {
    padding: "10px 12px"
  },
  copyButton: {
    marginLeft: theme.spacing(1)
  }
}));

const CopyInput = ({ text, disabled }) => {
  const classes = useStyles();
  const [copySuccess, setCopySuccess] = useState(false);
  const textFieldRef = useRef(null);

  // mostly pulled from:
  // https://stackoverflow.com/questions/34045777/copy-to-clipboard-using-javascript-in-ios
  const copyToClipboard = () => {
    const el = textFieldRef.current;

    if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
      const oldContentEditable = el.contentEditable;
      const oldReadOnly = el.readOnly;
      const range = document.createRange();

      el.contentEditable = true;
      el.readOnly = false;
      range.selectNodeContents(el);

      const s = window.getSelection();
      s.removeAllRanges();
      s.addRange(range);

      el.setSelectionRange(0, 999999); // A big number, to cover anything that could be inside the element.

      el.contentEditable = oldContentEditable;
      el.readOnly = oldReadOnly;
    } else {
      el.select();
    }

    document.execCommand('copy');
    setCopySuccess(true);
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setCopySuccess(false);
  };

  return (
    <div className={classes.wrapper}>
      <form className={classes.form}>
        <TextField
          inputRef={textFieldRef}
          value={text}
          variant="outlined"
          className={classes.input}
          disabled={disabled}
          inputProps={{
            className: classes.inputControl
          }}
        />
      </form>
      {
       /* Logical shortcut for only displaying the
          button if the copy command exists */
       typeof document !== 'undefined' && document.queryCommandSupported('copy') &&
        <Fragment>
          <Button
            onClick={copyToClipboard}
            variant="outlined"
            className={classes.copyButton}
            disabled={disabled}
          >
            Copy
          </Button>
          <Snackbar
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            open={copySuccess}
            autoHideDuration={3000}
            onClose={handleClose}
            ContentProps={{
              'aria-describedby': 'message-id',
            }}
            message={<span id="message-id">Invite link copied to clipboard</span>}
            action={[
              <IconButton
                key="close"
                aria-label="close"
                color="inherit"
                className={classes.close}
                onClick={handleClose}
              >
                <CloseIcon />
              </IconButton>
            ]}
          />
        </Fragment>
      }
    </div>
  );
};

CopyInput.propTypes = {
  text: PropTypes.string,
  disabled: PropTypes.bool
};

export default CopyInput;
